module.exports = __webpack_public_path__ + "static/media/Footer.b7267283.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/course/Footer.png
// module id = 859
// module chunks = 6